import { render, staticRenderFns } from "./confirmation-modal.vue?vue&type=template&id=753519d8&scoped=true"
import script from "./confirmation-modal.vue?vue&type=script&lang=js"
export * from "./confirmation-modal.vue?vue&type=script&lang=js"
import style0 from "./confirmation-modal.vue?vue&type=style&index=0&id=753519d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753519d8",
  null
  
)

export default component.exports